export default "__VITE_ASSET__2e96201b__"